import { useLocale, type Locale } from './index';

const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  lt: 'Lietuvių',
};

export function LocaleSwitcher() {
  const [locale, setLocale] = useLocale();

  return (
    <div
      role="radiogroup"
      aria-label="Select language"
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '1rem',
        zIndex: 1000,
        display: 'flex',
        gap: '0.35rem',
        backgroundColor: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        borderRadius: '8px',
        padding: '0.3rem',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0',
      }}
    >
      {(Object.keys(LOCALE_LABELS) as Locale[]).map((l) => (
        <button
          key={l}
          role="radio"
          aria-checked={locale === l}
          aria-label={LOCALE_LABELS[l]}
          onClick={() => setLocale(l)}
          style={{
            padding: '0.3rem 0.65rem',
            border: 'none',
            borderRadius: '6px',
            fontSize: '0.8rem',
            fontWeight: locale === l ? 600 : 400,
            color: locale === l ? '#222' : '#666',
            backgroundColor: locale === l ? '#e8f0fe' : 'transparent',
            cursor: 'pointer',
            transition: 'background-color 0.15s ease, color 0.15s ease',
            whiteSpace: 'nowrap',
            touchAction: 'manipulation',
          }}
        >
          {LOCALE_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
